var widgets = require('../lib/widgets');

widgets.create('HomeSlider_PTS', require('./HomeSlider_PTS'));
widgets.create('CourseFilter', require('./CourseFilter_PTS'));
widgets.create('FilterItem', require('./FilterItem_PTS'));
widgets.create('DateField', require('./DateField'));
widgets.create('Form_PTS', require('./Form_PTS'));
// widgets.create('Jcf_PTS', require('./Jcf_PTS'));
// widgets.create('CourseBookingForm_PTS', require('./CourseBookingForm_PTS'));
widgets.create('BookingFormFilter_PTS', require('./BookingFormFilter_PTS'));
widgets.create('CourseUpdate', require('./CourseUpdate'));
widgets.create('ContentSlider_PTS', require('./ContentSlider_PTS'));
widgets.create('LocMapMini_PTS', require('./LocMapMini_PTS'));



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/index_PTS.js
 ** module id = 261
 ** module chunks = 1
 **/